/** Compact inline meter for composers and settings panels. */
export function PhotoUploadMeter({ label, percent }: { label: string; percent: number }) {
  const value = Math.max(0, Math.min(100, Math.round(percent)));
  return (
    <div className="photo-upload-inline" role="status" aria-live="polite">
      <div className="photo-upload-banner-copy">
        <strong>{label}</strong>
        <span>{value}%</span>
      </div>
      <div
        className="photo-upload-meter"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={value}
        aria-label={label}
      >
        <i style={{ width: `${value}%` }} />
      </div>
    </div>
  );
}
